import React, { useEffect, useState } from "react";
import { Button, Grid, TextField, MenuItem, Checkbox, FormGroup, FormControlLabel, Typography } from '@mui/material'
import { DatePicker } from '@mui/lab';
import GridBreak from '../../../../components/GridBreak'
import IFramePopUp from '../../../../components/Pop_ups/IFramePopUp';
import DragFiles from "../../../../components/FileManagement/DragFiles";
import { fileTo64Arr, handleFormNumbers } from "../../../../util/generalHelp";
import { createContractDraft, submitDraft, removeOfferDraft, getFieldClause } from "../../../../util/offerLettersHelp";
import { previewDocusign } from "../../../../util/docusignHelper";
import { useBeforeunload } from 'react-beforeunload';
import { useBackListener } from "../../../../util/Hooks";
import moment from "moment";
import { getProfileFromEmail } from "../../../../util/ProfileHelper";

function StatementOfWork(props) {

    const defaultObj = {
    document_args: {
        "salary": 0,
        "rate_type": "daily",
        venue: 'New York, NY',
        jurisdiction: 'New York',
        contractor_name: "",
        service_description: ""
    },
    region: 'USA',
    name: "",
    email_address: "",
    authority_id: null,
    "return_url": window.location.origin.toString(),
    venue_id: "",
    state_id: "",

    }
    
        const defaultFieldsStatementOfWork = {
            services: false,
            performance_period: false,
            fees: false,
            payment_terms: false,
            customStatementOfWork: false
        }
    
       const changeFieldStatementOfWork = function (field, value) 
        {
            let newFieldsStatementOfWork = { ...fieldsStatementOfWork }
            if (!value)
            {
                const keyClause = field
                let newShowEdits = {...showEditClause}
                newShowEdits[keyClause] = false
                setShowEditClause(newShowEdits)
                let newDefaultContractText = {...defaultContractText}
                delete newDefaultContractText[keyClause]
                setDefaultContractText(newDefaultContractText)
            }
            newFieldsStatementOfWork[field] = value
            setFieldsStatementOfWork(newFieldsStatementOfWork)
        }
    
        const handleDefaultClause = function (keyClause, contract, checked)
        {
            props.setLoading(true)
            if (checked)
            {
                if (!defaultContractText[keyClause])
                    getFieldClause(keyClause, contract, 'usa_contract', (json) =>
                {
                    if (json)
                    {
                        let newDefaultContractText = {...defaultContractText}
                        newDefaultContractText[keyClause] = json.clauses
                        setDefaultContractText(newDefaultContractText)
                        let newShowEdits = {...showEditClause}
                        newShowEdits[keyClause] = true
                        setShowEditClause(newShowEdits)
                    }
                    else
                        props.setError("The requested clause text could not be fetched. This is usually due to server error.")
                props.setLoading(false)
                })
                else
                {
                    let newShowEdits = {...showEditClause}
                    newShowEdits[keyClause] = true
                    setShowEditClause(newShowEdits)
                    props.setLoading(false)
                }
            }
            else
            {
                let newShowEdits = {...showEditClause}
                newShowEdits[keyClause] = false
                setShowEditClause(newShowEdits)
                let newDefaultContractText = {...defaultContractText}
                delete newDefaultContractText[keyClause]
                setDefaultContractText(newDefaultContractText)
                props.setLoading(false)
            }
        }
    
        const [requestObj, setRequestObj] = useState({ ...defaultObj })
        const [previewUrl, setPreviewUrl] = useState()
        const [previewClicked, setPreviewClicked] = useState(false)
        const [envelopeId, setEnvelopeId] = useState("")
        const [fileArr, setFileArr] = useState([])
        const [uploadStatus, setUploadStatus] = useState('error')
        const [fieldsStatementOfWork, setFieldsStatementOfWork] = useState({ ...defaultFieldsStatementOfWork })
        const [defaultContractText, setDefaultContractText] = useState({})
        const [showEditClause, setShowEditClause] = useState({})
        const [checkAll, setCheckAll] = useState(false)
    
        useEffect(() => {
            if (fieldsStatementOfWork.services)
            {
                let newObj = {...requestObj}
                newObj['document_args']['client_name'] = ""
                newObj['document_args']['service_description'] = ""
                setRequestObj(newObj)
            }
            else
            {
                let newObj = {...requestObj}
                delete newObj['document_args']['client_name']
                delete newObj['document_args']['service_description']
                setRequestObj(newObj)
            }
        }    
        , [fieldsStatementOfWork.services])
    
        useEffect(() => {
            if (fieldsStatementOfWork.payment_terms)
            {
                let newObj = {...requestObj}
                newObj['document_args']['reciept_clause_included'] = true
                setRequestObj(newObj)
            }
            else
            {
                let newObj = {...requestObj}
                delete newObj['document_args']['reciept_clause_included']
                setRequestObj(newObj)
            }
        }    
        , [fieldsStatementOfWork.payment_terms])
    
        useEffect(() => {
            if (fieldsStatementOfWork.performance_period)
            {
                let newObj = {...requestObj}
                newObj['document_args']['effective_date'] = moment().format('YYYY-MM-DD')
                setRequestObj(newObj)
            }
            else
            {
                let newObj = {...requestObj}
                delete newObj['document_args']['effective_date']
                setRequestObj(newObj)
            }
        }    
        , [fieldsStatementOfWork.performance_period])
    
        useEffect(() => {
            if (fieldsStatementOfWork.fees)
            {
                let newObj = {...requestObj}
                newObj['document_args']['rate_type'] = "daily"
                newObj['document_args']['salary'] = 0
                setRequestObj(newObj)
            }
            else
            {
                let newObj = {...requestObj}
                delete newObj['document_args']['rate_type']
                delete newObj['document_args']['salary']
                setRequestObj(newObj)
            }
        }    
        , [fieldsStatementOfWork.fees])
    
        useEffect(() => {
                if (fileArr && fileArr.length > 0) {
                    setUploadStatus('success')
                } else {
                    setUploadStatus('pending')
                }
            }, [fileArr])
    
        useBackListener(({ location }) => {
                if (requestObj.id) {
                    removeOfferDraft(requestObj.id, (resp) => { }, true)
                }
            })
        
        
            useBeforeunload((event) => {
                if (requestObj.id) {
                    removeOfferDraft(requestObj.id, (resp) => { }, true)
        
                }
            });
    
        const closePreview = () => {
                setPreviewClicked(false)
                previewDocusign(envelopeId, (json) => {
                    if (json) {
                        setPreviewUrl(json.redirect_url)
                    }
                })
            }
    
        const updateDocument = (key, value) => {
                let newDoc = { ...requestObj }
                if (key == 'seq_hire_helper') {
                    newDoc['document_args']['seq_hire_statement'] = defaultObj.document_args.seq_hire_statement.replace(/X/, `${value}`)
                }
                    newDoc['document_args'][key] = value
                setRequestObj(newDoc)
            }
    
        const handleDraft = async () => {
                if (previewUrl && requestObj.id) {
                    props.setLoading(true)
                    submitDraft(requestObj.id, envelopeId, (resp) => {
                        if (resp) {
                            setRequestObj(defaultObj)
                            setFileArr([])
                            setPreviewUrl()
                            setEnvelopeId("")
                            if (props.onComplete) {
                                props.onComplete()
                            }
                        } else {
                            props.onError({})
                        }
                        props.setLoading(false)
                    })
                } else {
                    props.setLoading(true)
                    setPreviewUrl()
                    if (checkJson(requestObj.document_args)) {
                        getProfileFromEmail(async (profile) => 
                        {
                        let request_obj = { ...requestObj }
                        request_obj.document_b64s = await handleFile(fileArr)
                        const jsonSend = {request_obj: request_obj, contract: 'StatementOfWork', fields: ['fieldsStatementOfWork'], fieldsStatementOfWork: fieldsStatementOfWork, default_changes: defaultContractText, sender: profile.id}
                        createContractDraft(jsonSend, (resp) => {
                            if (resp) {
                                updateOffer('id', resp.id)
                                setPreviewUrl(resp.redirect_url)
                                setUploadStatus('disabled')
                                setEnvelopeId(resp.envelope_id)
                            } else {
                                props.onError({})
                            }
                            props.setLoading(false)
                        })
                    })
                    } else {
                        props.onError({ errorTitle: 'Missing Form Fields', errorContent: "Please fill out all available form fields" })
                        props.setLoading(false)
                    }
        
                }
        
            }
        
        const checkJson = (json) => {
                for (const key of Object.keys(json)) {
                    if (json[key] === null || json[key] === undefined || json[key] === '') {
                        console.log('key', key)
                        if (!props.optionalFields.includes(key))
                            return false
                    }
        
                    if (json[key].constructor == Object) {
                        if (!checkJson(json[key])) {
                            return false
                        }
                        continue
                    }
                }
                return true
            }
        
            const updateOffer = (key, value, del = false) => {
                let newOffer = { ...requestObj }
                if (!del) {
                    newOffer[key] = value
                    setRequestObj(newOffer)
                } else {
                    delete newOffer[key]
                    setRequestObj(newOffer)
                }
        
            }    
    
        const handleClear = () => {
            if (requestObj.id) {
                props.setLoading(true)
                removeOfferDraft(requestObj.id, (resp) => {
                    if (resp) {
                        let newOffer = { ...requestObj }
                        delete newOffer['id']
                        setRequestObj(newOffer)
                        setPreviewUrl()
                        setUploadStatus('pending')
                    } else {
                        props.onError({})
                    }
                    props.setLoading(false)
                })
            }
        }
    
        const handleFile = async (fileArr) => {
            return await fileTo64Arr(fileArr)
        }
    
        const handleNumberForm = (e, key, document = false, decimals = 0, maxdigits = undefined) => {
            let modfiedNum = handleFormNumbers(e.target.value, decimals, false, maxdigits)
            if (modfiedNum !== undefined) {
                if (document) {
                    updateDocument(key, modfiedNum)
                } else {
                    updateOffer(key, modfiedNum)
                }
            }
        }
    
    
        const handleCheckAll = (e) => {
            let newFieldsStatementOfWork = { ...fieldsStatementOfWork }
            for (const key of Object.keys(newFieldsStatementOfWork)) {
                newFieldsStatementOfWork[key] = e.target.checked
            }
            setFieldsStatementOfWork(newFieldsStatementOfWork)
            setCheckAll(e.target.checked)
        }
    
        //Length is the maximum length of the clause in question, in case there are multiple fields
        const changeDefaultText = function (key, value, index, length)
        {
            let newDefault = {...defaultContractText}
            if (index && newDefault[key])
                newDefault[key][index] = value
            else if (index)
            {
                newDefault[key] = Array(length)
                newDefault[key][index] = value
            }
            else
                newDefault[key] = value
            setDefaultContractText(newDefault)
        }
    

    


    return (
        <Grid container spacing={2} sx={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', width: '100%', padding: '1%' }}>
            <IFramePopUp open={previewClicked} url={previewUrl} onClose={closePreview} maxRedirect={2} />
            <Typography sx ={{'align-self': 'flex-start'}} variant='h5'>Choose Fields</Typography>
            <FormGroup item sx={{ width: '100%', padding: '1%' }}>
            <FormControlLabel control={ <Checkbox checked = {checkAll} onChange = {handleCheckAll} /> } label = {"Check/Uncheck All"} />
            <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.services} onChange = {(e) => changeFieldStatementOfWork("services", e.target.checked)} /> } label = {"Statement of Work Services"} />
            {fieldsStatementOfWork.services ?
                <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                    <FormControlLabel  control={ <Checkbox checked = {showEditClause.services} onChange = {(e) => handleDefaultClause("services", "StatementOfWork", e.target.checked)} /> } label = {"Edit Services Clause"} />
                    {showEditClause.services ?
                    <>
                        <Typography sx = {{'margin': '1%'}}>
                        The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                        </Typography>
                        <TextField sx = {{'margin': '1%'}} label="Current Services Clause"
                            value= {defaultContractText.services} onChange= {(e) => changeDefaultText("services", e.target.value)} fullWidth required multiline />     
                    </> 
                    : <></>
                    }
                </Grid> : <></>
            }
            <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.fees} onChange = {(e) => changeFieldStatementOfWork("fees", e.target.checked)} /> } label = {"Statement of Work Fees"} />
            <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.performance_period} onChange = {(e) => changeFieldStatementOfWork("performance_period", e.target.checked)} /> } label = {"Statement of Work Performance Period"} />
            {fieldsStatementOfWork.performance_period ?
                <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                    <FormControlLabel  control={ <Checkbox checked = {showEditClause.performance_period} onChange = {(e) => handleDefaultClause("performance_period", "StatementOfWork", e.target.checked)} /> } label = {"Edit Performance Period Clause"} />
                    {showEditClause.performance_period ?
                    <>
                        <Typography sx = {{'margin': '1%'}}>
                            The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                        </Typography>
                        <TextField sx = {{'margin': '1%'}} label="Current Performance Period Clause"
                            value= {defaultContractText.performance_period} onChange= {(e) => changeDefaultText("performance_period", e.target.value)} fullWidth required multiline />
                    </> : <></>
                    }
                </Grid> : <></>
            }
            <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.payment_terms} onChange = {(e) => changeFieldStatementOfWork("payment_terms", e.target.checked)} /> } label = {"Statement of Work Payment Terms"} />
            {fieldsStatementOfWork.payment_terms ?
                <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                    
                    <FormControlLabel  control={ <Checkbox checked = {showEditClause.payment_terms} onChange = {(e) => handleDefaultClause("payment_terms", "StatementOfWork", e.target.checked)} /> } label = {"Edit Payment Terms Clause"} />
                    {showEditClause.payment_terms ?
                    <>
                        <Typography sx = {{'margin': '1%'}}>
                            The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                        </Typography>
                        <TextField sx = {{'margin': '1%'}} label="Current Payment Terms Clause"
                            value= {defaultContractText.payment_terms} onChange= {(e) => changeDefaultText("payment_terms", e.target.value)} fullWidth required multiline /> 
                    </> : <></>
                    }
                </Grid> : <></>
            }
            <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.customStatementOfWork} onChange = {(e) => changeFieldStatementOfWork("customStatementOfWork", e.target.checked)} /> } label = {"Add a Statement of Work Custom Field"} />
            {fieldsStatementOfWork.customStatementOfWork ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <TextField sx = {{'margin': '1%'}} label="Current Statement of Work Custom Header"
                            value= {defaultContractText.customStatementOfWorkHeader} onChange= {(e) => changeDefaultText("customStatementOfWorkHeader", e.target.value)} fullWidth required />
                        <TextField sx = {{'margin': '1%'}} label="Current Statement of Work Custom Clause"
                            value= {defaultContractText.customStatementOfWork} onChange= {(e) => changeDefaultText("customStatementOfWork", e.target.value)} fullWidth required multiline />
                    </Grid>
                        : <></>
            }
            </FormGroup>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Signatory Name" onChange={(e) => { e.preventDefault(); updateOffer('name', e.target.value) }}
                            value={requestObj.name} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Contractor Name" onChange={(e) => { e.preventDefault(); updateDocument('contractor_name', e.target.value) }}
                            value={requestObj.document_args.contractor_name} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Company Name" onChange={(e) => { e.preventDefault(); updateDocument('company_name', e.target.value) }}
                            value={requestObj.document_args.company_name} fullWidth required />
                    </Grid>
                    { fieldsStatementOfWork.services ? 
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Client Name" onChange={(e) => { e.preventDefault(); updateDocument('client_name', e.target.value) }}
                            value={requestObj.document_args.client_name} fullWidth required />
                    </Grid> : <></> }
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Signatory Email" onChange={(e) => { e.preventDefault(); updateOffer('email_address', e.target.value) }}
                            value={requestObj.email_address} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Region" required onChange={(e) => { e.preventDefault(); updateOffer('region', e.target.value) }}
                            value={requestObj.region} fullWidth select>
                            <MenuItem key={1} value="CAN">
                                CAN
                            </MenuItem>
                            <MenuItem key={2} value="USA">
                                USA
                            </MenuItem>
                        </TextField>
                    </Grid>
                    {fieldsStatementOfWork.performance_period ? 
                        <Grid item xs={3}>
                        <DatePicker disabled={Boolean(previewUrl)} label="SOW Effective Date" value={requestObj.document_args.effective_date}
                            onChange={(value) => updateDocument('effective_date', value.format('YYYY-MM-DD').toString())}
                            renderInput={(params) => <TextField required fullWidth {...params} />} />
                        </Grid>
                        : <></>
                    }
                    
                    { fieldsStatementOfWork.fees ?
                        <Grid item xs={3}>
                            <TextField disabled={Boolean(previewUrl)} label="Payment Type" required onChange={(e) => { e.preventDefault(); updateDocument('rate_type', e.target.value) }}
                                value={requestObj.document_args.rate_type} fullWidth select>
                                <MenuItem key={1} value="daily">
                                    Daily
                                </MenuItem>
                                <MenuItem key={2} value="hourly">
                                    Hourly
                                </MenuItem>
                            </TextField>
                        </Grid> : <></> }
                    { fieldsStatementOfWork.fees ? 
                        <Grid item xs={3}>
                            <TextField disabled={Boolean(previewUrl)} SelectProps='0.01' onChange={(e) => {
                                e.preventDefault();
                                handleNumberForm(e, 'salary', true, 2)
                            }}
                                label={requestObj.document_args.rate_type == 'daily' ? "Daily Rate ($)" : 'Hourly Rate ($/hr)'}
                                value={requestObj.document_args.salary} fullWidth required />
                        </Grid>    
                    : <></>
                    }
                    {fieldsStatementOfWork.services ?
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Service Description" onChange={(e) => { e.preventDefault(); updateDocument('service_description', e.target.value) }}
                            value={requestObj.document_args.service_description} fullWidth required multiline />
                    </Grid>
                    : <></> }   
                    { fieldsStatementOfWork.payment_terms ?
                    <Grid item xs={3}>
                        <TextField label="5 Days Reciept Clause Included" required disabled={previewUrl} onChange={(e) => { e.preventDefault(); updateDocument('reciept_clause_included', e.target.value) }}
                            value={requestObj.document_args.reciept_clause_included} fullWidth select>
                            <MenuItem value={true}>
                                Yes
                            </MenuItem>
                            <MenuItem value={false}>
                                No
                            </MenuItem>
                        </TextField>
                    </Grid>
                    : <></> }
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} required label="Jurisdiction"
                            onChange={(e) => { e.preventDefault(); updateOffer('state_id', e.target.value) }}
                            value={requestObj.state_id} fullWidth select>
                            {props.states.map((auth) => (
                                <MenuItem key={auth.id} value={auth.id}>
                                    {auth.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl) || !requestObj.state_id} required label="Venue"
                            onChange={(e) => { e.preventDefault(); updateOffer('venue_id', e.target.value) }}
                            value={requestObj.venue_id} fullWidth select>
                            {props.venues.filter(v => v.type === requestObj.state_id).map((auth) => (
                                <MenuItem key={auth.id} value={auth.id}>
                                    {auth.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} required label="Signing Authority" onChange={(e) => { e.preventDefault(); updateOffer('authority_id', e.target.value) }}
                            value={requestObj.authority_id} fullWidth select>
                            {props.authorities.map((auth) => (
                                <MenuItem key={auth.id} value={auth.id}>
                                    {auth.name}({auth.email_address})
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Statement Of Work Number"
                            onChange={(e) => {
                                e.preventDefault();
                                updateDocument('SOW_number', e.target.value)
                            }}
                            value={requestObj.document_args.SOW_number} fullWidth required multiline />
                    </Grid>
                    <GridBreak />
                    <Grid item container xs={12} sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <DragFiles types={props.fileTypes} multiple={true} disabled={Boolean(previewUrl)} onUpdate={setFileArr}
                            maxSize={15}
                            onTypeError={(error) => { setUploadStatus('error'); props.onError({ errorTitle: 'File Type Error', errorContent: error }) }}
                            onSizeError={(error) => { setUploadStatus('error'); props.onError({ errorTitle: 'File Size Error', errorContent: error }) }}
                            uploadStatus={uploadStatus} />
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <Button fullWidth disabled={!previewUrl || !requestObj.id} onClick={(e) => { e.preventDefault(); handleClear() }}>Cancel</Button>
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <Button fullWidth disabled={!previewUrl || !requestObj.id} onClick={(e) => { e.preventDefault(); setPreviewClicked(true) }}>Preview Document</Button>
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <Button fullWidth onClick={(e) => { e.preventDefault(); handleDraft() }}>{requestObj.id && previewUrl ? "Send" : "Create Draft"}</Button>
                    </Grid>
                </Grid>
    );
}

export default StatementOfWork;